export default __webpack_public_path__ + "static/BrownStd-Bold-04cac606251e492637f45359b7e8ccde.woff";